
import { Box, Typography, Grid, Card, CardContent, Avatar, Rating } from '@mui/material';
import { motion } from 'framer-motion';
import reviews from './utils/ReviewsMockData.json'
import {theme} from './utils/theme'
import Section from './utils/section';

function ReviewsSection() {
    return (
        <Section title="What Our Customers Say">
            <Grid container spacing={4}>
                {reviews.map((review, index) => (
                    <Grid item key={index} size={{xs:12, md:6, lg:4}}>
                        <motion.div whileHover={{ y: -5 }} transition={{ duration: 0.2 }}>
                            <Card  sx={{display:'flex', p: 2, borderRadius: '20px', background: theme.palette.background.paper, backdropFilter: 'blur(10px)', flexGrow: 1 }}>
                              <CardContent sx={{ flexGrow: 1 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                      <Avatar src={review.image} alt={review.name} sx={{ width: 56, height: 56, mr: 2 }} />
                                      <Box>
                                          <Typography variant="h6" component="div">{review.name}</Typography>
                                          <Rating value={review.rating} precision={0.5} readOnly />
                                      </Box>
                                  </Box>
                                  <Typography sx={{overflow: 'hidden',display: '-webkit-box',WebkitLineClamp: 3,WebkitBoxOrient: 'vertical',}} variant="body2" color="#2b394a">
                                      "{review.feedback}"
                                  </Typography>
                              </CardContent>
                            </Card>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>
        </Section>
    );
}

export default ReviewsSection